export const UploadIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.33301 13.3346L3.33301 14.168C3.33301 15.5487 4.45229 16.668 5.833 16.668L14.1663 16.668C15.547 16.668 16.6663 15.5487 16.6663 14.168L16.6663 13.3346M13.333 6.66797L9.99966 3.33464M9.99966 3.33464L6.66634 6.66797M9.99966 3.33464L9.99966 13.3346"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
